import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import PortalVue from 'portal-vue'
import VueCardFormat from 'vue-credit-card-validation'
import VueMask from 'v-mask'

Vue.use(Vuelidate)
Vue.use(Element, { locale })
Vue.use(PortalVue)
Vue.use(VueCardFormat)
Vue.use(VueMask)
